import type { Item } from '@mimir/common/dto/searchResultHit';
import { SearchDateOption } from '@mimir/common/dto/searchModels';
import { ComputedTechnicalField, TechnicalAudioAndVideoDataField, TechnicalImageDataField, TechnicalVideoDataField } from '@mimir/common/util/technicalMetadata';

export enum ViewType {
  LIST = 'list',
  GRID = 'grid',
  COMPACT = 'compact',
  MAP = 'map'
}

export type SystemFieldIdTypeForConfiguringCompactView = keyof Item | 'scheduledRecording.startTimeMs' | 'highresDeletion.deletionState' | 'highresDeletion.deletionDate' | 'hasRelations';

interface SystemProp {
  fieldId: SystemFieldIdTypeForConfiguringCompactView;
  label: string;
}

export const systemFields: SystemProp[] = [
  { fieldId: 'originalFileName', label: 'File name' },
  { fieldId: 'mediaDuration', label: 'Duration' },
  { fieldId: 'mediaSize', label: 'File size' },
  { fieldId: 'id', label: 'Item id' },
  { fieldId: 'createdOn', label: 'Creation date' },
  { fieldId: 'proxySize', label: 'Proxy size' },
  { fieldId: 'itemState', label: 'Item status' },
  { fieldId: 'itemType', label: 'Item type' },
  { fieldId: 'mediaType', label: 'Media type' },
  { fieldId: 'modifiedOn', label: 'Modified date' },
  { fieldId: 'isArchived', label: 'Is archived' },
  { fieldId: 'createdBy', label: 'Owner' },
  { fieldId: 'scheduledRecording.startTimeMs', label: 'Planned ingest time' },
  { fieldId: 'transcriptionState', label: 'Transcription status' },
  { fieldId: 'languageCode', label: 'Transcription language' },
  { fieldId: 'visibleTo', label: 'Visibility' },
  { fieldId: 'highresDeletion.deletionState', label: 'Highres deletion state' },
  { fieldId: 'highresDeletion.deletionDate', label: 'Highres deletion date' },
  { fieldId: 'hasRelations', label: 'Has relations' },
  { fieldId: 'customIcons', label: 'Custom icons' },
];

export const technicalFields = [
  { label: 'Media Width', fieldId: ComputedTechnicalField.Width },
  { label: 'Media Height', fieldId: ComputedTechnicalField.Height },
  { label: 'Duration', fieldId: TechnicalAudioAndVideoDataField.Duration },
  { label: 'Container', fieldId: TechnicalAudioAndVideoDataField.ContainerFormat },
  { label: 'Codec name', fieldId: TechnicalAudioAndVideoDataField.CodecName },
  { label: 'Codec tag', fieldId: TechnicalAudioAndVideoDataField.CodecTag },
  { label: 'Bitrate', fieldId: TechnicalAudioAndVideoDataField.BitRate },
  { label: 'Frame rate', fieldId: TechnicalVideoDataField.FrameRate },
  { label: 'Audio channels', fieldId: TechnicalAudioAndVideoDataField.AudioChannels },
  { label: 'Audio channels in stream', fieldId: TechnicalAudioAndVideoDataField.AudioChannelsInStreams },
  { label: 'Audio sample rate', fieldId: TechnicalAudioAndVideoDataField.AudioSampleRate },
  { label: 'Is truncated', fieldId: TechnicalAudioAndVideoDataField.IsTruncated },
  { label: 'Field order', fieldId: TechnicalVideoDataField.FieldOrder },
  { label: 'Color space', fieldId: TechnicalVideoDataField.ColorSpace },
  { label: 'Image type', fieldId: TechnicalImageDataField.FileType }
];

const searchRegExp = /_/g;
export const dateRangeLabelMap: Record<SearchDateOption, string> = {
  [SearchDateOption.ANYTIME]: SearchDateOption.ANYTIME.replace(searchRegExp, ' '),
  [SearchDateOption.PAST_HOUR]: SearchDateOption.PAST_HOUR.replace(searchRegExp, ' '),
  [SearchDateOption.PAST_24_HOURS]: SearchDateOption.PAST_24_HOURS.replace(searchRegExp, ' '),
  [SearchDateOption.PAST_WEEK]: SearchDateOption.PAST_WEEK.replace(searchRegExp, ' '),
  [SearchDateOption.PAST_MONTH]: SearchDateOption.PAST_MONTH.replace(searchRegExp, ' '),
  [SearchDateOption.PAST_YEAR]: SearchDateOption.PAST_YEAR.replace(searchRegExp, ' '),
  [SearchDateOption.PAST]: SearchDateOption.PAST.replace(searchRegExp, ' '),
  [SearchDateOption.FUTURE]: SearchDateOption.FUTURE.replace(searchRegExp, ' '),
  [SearchDateOption.CUSTOM]: SearchDateOption.CUSTOM.replace(searchRegExp, ' '),
};
